import {useLeftyTemplate, useLeftyUpdate} from 'Event/template/Lefty'
import ColorPicker from 'lib/ui/ColorPicker'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import Slider from 'lib/ui/Slider'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import {Controller} from 'react-hook-form'

export default function LeftPanelConfig() {
  const save = useLeftyUpdate()
  const {login} = useLeftyTemplate()

  const {
    form: {control},
  } = useConfig()

  return (
    <Config title="Login Content Left Panel" onSave={save}>
      <StylingPanel>
        <CollapsibleSection
          label="Background"
          storageKey="login.content.leftpanel.config"
        >
          <Controller
            name="login.leftPanel.backgroundColor"
            defaultValue={login.leftPanel.backgroundColor}
            control={control}
            render={({value, onChange}) => (
              <ColorPicker
                label="Color"
                color={value}
                onPick={onChange}
                aria-label="login content left panel background color"
              />
            )}
          />
          <Controller
            name="login.leftPanel.backgroundOpacity"
            defaultValue={login.leftPanel.backgroundOpacity}
            control={control}
            render={({value, onChange}) => (
              <Slider
                label="Opacity"
                unit="%"
                valueLabelDisplay="auto"
                aria-label="login content left panel background opacity"
                value={value}
                onChange={onChange}
                step={1}
                min={0}
                max={100}
              />
            )}
          />
        </CollapsibleSection>
      </StylingPanel>
    </Config>
  )
}
